<template>
  <div v-if="isShowLayout">
  <sidenav :custom_class="color" :class="[isRTL ? 'fixed-end' : 'fixed-start']" v-if="showSidenav" />
  <main class="main-content position-relative max-height-vh-100 h-100 overflow-x-hidden">
    <!-- nav -->
    <navbar :class="[isNavFixed ? navbarFixed : '', isAbsolute ? absolute : '']"
      :color="isAbsolute ? 'text-white opacity-8' : ''" :minNav="navbarMinimize" v-if="showNavbar" />
    <router-view />
  </main>
  </div>
  <div v-else-if="loadFailed" class="mbr-app-error" role="alert">
    <span class="mbr-app-error__icon" aria-hidden="true">
      <i class="material-icons-round">cloud_off</i>
    </span>
    <h2 class="mbr-app-error__title">{{ $t('app.load_failed') }}</h2>
    <p class="mbr-app-error__sub">{{ $t('legal.check_connection') }}</p>
    <material-button class="mbr-app-error__retry" :disabled="isRetrying" @click="retryMerchantSetting()">{{ $t('legal.try_again') }}</material-button>
  </div>
</template>
<script>
import Sidenav from "./common/Sidenav";
import Navbar from "@/common/Navbars/Navbar.vue";
import MaterialButton from "@/components/MaterialButton.vue";
import { mapMutations, mapState, mapActions } from "vuex";
import $ from "jquery";
import MerchantService from "@/services/merchant.service";
import { localStorageName, getMerchantCode } from "@/config/utils";
import { themeColorTokens, THEME_COLOR_TOKEN_NAMES } from "@/config/themeColor";

export default {
  name: "App",
  components: {
    Sidenav,
    Navbar,
    MaterialButton
  },
  data() {
    return {
      isShowLayout: false,
      loadFailed: false,
      isRetrying: false,
    }
  },
  mounted() {
    if (window.innerWidth < 1200) {
      $(".icon-close-sidenav-main").show();
    } else {
      $(".icon-close-sidenav-main").hide();
    }
    var _this = this;
    setTimeout(function() {
      const merchantCode = getMerchantCode();
      if(merchantCode) {
        _this.getSttingMerchant(merchantCode);
      }
    },100)
  },
  methods: {
    ...mapMutations(["toggleConfigurator", "navbarMinimize"]),
    ...mapActions(["setMerchantSetting", "setMerchantLogo", "setBackgroundColor", "setLabelColor", "setButtonColor", "setButtonTextColor", "setHasWaBalance"]),
    getSttingMerchant(merchantCode) {
      this.isShowLayout = false;
      return MerchantService.getMerchantSetting(merchantCode)
        .then((response) => {
          var dataSetting = response.data;
          if (dataSetting.result.isSuccess) {
            this.setMerchantLogo(dataSetting.data.data_merchant_setting.merchant_logo ?? '');
            this.setBackgroundColor(dataSetting.data.data_merchant_setting.bg_color ?? '#fef7e5');
            this.setLabelColor(dataSetting.data.data_merchant_setting.label_color ?? '#ffbe30');
            this.setButtonColor(dataSetting.data.data_merchant_setting.button_color ?? '#ffbe30');
            this.setButtonTextColor(dataSetting.data.data_merchant_setting.button_text_color ?? '#ffbe30');
            this.applyMerchantColors(dataSetting.data.data_merchant_setting);
            this.applyThemeColor(dataSetting.data.data_merchant_setting.mbr_theme_color);
            this.setHasWaBalance(dataSetting.data.getWaBalanceByAdminMerchant >= 1);
            localStorage.setItem(localStorageName('MERCHANT_ID'), dataSetting.data.merchantId ?? 0)
            localStorage.setItem(localStorageName('MERCHANT_BRAND_NAME'), dataSetting.data.merchant_brand_name ?? '')
            localStorage.setItem(localStorageName('IS_CHECK_MERCHANT_CONNECTED_STRIPE'), dataSetting.data.isCheckMerchantConnectedStripe ?? '');
            localStorage.setItem(localStorageName('SHOW_TOPUP_BUTTON_ON_HOME'), dataSetting.data.data_merchant_setting.show_topup_button_on_home ?? 0);
            localStorage.setItem(localStorageName('MBR_LOGIN_BG_IMAGE'), dataSetting.data.data_merchant_setting.mbr_login_bg_image ?? '');
            localStorage.setItem(localStorageName('ALLOW_RESET_PASSCODE_TO_BIRTHDAY'), dataSetting.data.data_merchant_setting.allow_reset_passcode_to_birthday ?? '');
            localStorage.setItem(localStorageName('ALLOW_RESET_PASSCODE_TO_ONE_TIME_OTP'), dataSetting.data.data_merchant_setting.allow_reset_passcode_to_one_time_otp ?? '');
            localStorage.setItem(localStorageName('SENDING_OTP_SIGNUP'), dataSetting.data.data_merchant_setting.sending_otp_signup ?? 0);
            localStorage.setItem(localStorageName('ALLOW_FOREIGNER_PHONE_NUMBER'), dataSetting.data.data_merchant_setting.allow_foreigner_phone_number ?? '');
            localStorage.setItem(localStorageName('ONLY_ALLOW_EXISTING_MEMBER_MOO_LOGIN'), dataSetting.data.data_merchant_setting.only_allow_existing_member_moo_login ?? 'false');
            this.loadFailed = false;
            this.isShowLayout = true;
          } else {
            this.loadFailed = true;
          }
        },
          (error) => {
            // no response at all on a network failure
            console.log(error.response?.status)
            this.loadFailed = true;
          }
        );
    },
    retryMerchantSetting() {
      this.isRetrying = true;
      this.getSttingMerchant(getMerchantCode()).finally(() => {
        this.isRetrying = false;
      });
    },
    // MBR theme tokens (theme-tokens.css) read these; an unset color falls back to the design palette.
    applyMerchantColors(setting) {
      const root = document.documentElement.style;
      const colors = {
        "--mbr-merchant-bg-color": setting.bg_color,
        "--mbr-merchant-label-color": setting.label_color,
        "--mbr-merchant-button-color": setting.button_color,
        "--mbr-merchant-button-text-color": setting.button_text_color,
      };
      Object.keys(colors).forEach((name) => {
        if (colors[name]) {
          root.setProperty(name, colors[name]);
        } else {
          root.removeProperty(name);
        }
      });
    },
    // MBR128: the merchant's theme colour overrides the brand tokens; unset keeps the design palette.
    applyThemeColor(color) {
      const root = document.documentElement.style;
      const tokens = themeColorTokens(color);
      THEME_COLOR_TOKEN_NAMES.forEach((name) => {
        if (tokens) {
          root.setProperty(name, tokens[name]);
        } else {
          root.removeProperty(name);
        }
      });
    }
  },
  computed: {
    ...mapState([
      "isRTL",
      "color",
      "isAbsolute",
      "isNavFixed",
      "navbarFixed",
      "absolute",
      "showSidenav",
      "showNavbar",
      "showFooter",
      "showConfig",
      "hideConfigButton"
    ]),
  },
  beforeMount() {
    this.$store.state.isTransparent = "bg-transparent";

    const sidenav = document.getElementsByClassName("g-sidenav-show")[0];

    if (window.innerWidth > 1200) {
      sidenav.classList.add("g-sidenav-pinned");
    }
  }
};
</script>
<style scoped>
/* get-merchant-setting failed — same look as the Privacy/Terms load error */
.mbr-app-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 100vh;
  padding: 24px 16px;
  text-align: center;
  background: var(--mbr-color-canvas);
}

.mbr-app-error__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  margin-bottom: 8px;
  background: var(--mbr-color-tint);
  border-radius: var(--mbr-radius-full);
  color: var(--mbr-color-primary);
}

.mbr-app-error__icon .material-icons-round {
  font-size: 32px;
}

/* font-family/color set explicitly: Material Dashboard forces Roboto Slab on h1-h3 */
.mbr-app-error__title {
  margin: 0;
  font-family: var(--mbr-font-headline);
  font-size: var(--mbr-headline-sm-size);
  font-weight: 700;
  line-height: var(--mbr-headline-sm-line);
  color: var(--mbr-color-ink-headline);
}

.mbr-app-error__sub {
  margin: 0;
  font-size: 14px;
  line-height: 20px;
  color: var(--mbr-color-ink-muted);
}

.mbr-app-error__retry {
  min-width: 160px;
  margin-top: 12px;
}
</style>
